module.exports = __webpack_public_path__ + "static/3_3_spam-or-ham_PT-1d2e5b65fe28c70cd5daab1b8aa22aac.svg";